export const ModalNamesGA = {
  CreatePackFromScratch: 'Create Pack from Scratch',
  CreateCopy: 'Create Copy',
  CreateRevision: 'Create Revision',
  CreateSisterLocal: "Create 'Sister'/'Local'",
  CreatePackFromExistingPack: 'Create Pack from Existing Pack',
  MakePrototype: 'Make Prototype',
  MakeContract: 'Make Contract',
  RouteQuote: 'Route Quote',
  PackProperties: 'Pack Properties',
  SendToIrisStaging: 'Send to IRIS Staging',
  ProductPage: 'Product Page',
  EnlargedImage: 'Enlarged Image',
  WhereUsed: 'Where Used',
  PackNotifications: 'Pack Notifications',
  CurrencySettings: 'Currency Settings',
  SelectQuoteToAddItem: 'Select a Quote to Add Item',
  ReplacePart: 'Replace Part',
  CompareSelectedItems: 'Compare Selected Items',
  ViewOtherUsersInbox: 'View Other User’s Inbox',
  UserDetails: 'User Details',
  CreateMasterTemplate: 'Create Master Template',
  CategoriesTree: 'Categories Tree',
  AccountProperties: 'Account Properties',
  AddItemsToPack: 'Add Items to Pack',
  NewECO: 'New ECO',
  ViewECO: 'View ECO',
  EditECO: 'Edit ECO',
  ConfirmECODeletion: 'Confirm ECO Deletion',
  ConfirmPackDeletion: 'Confirm Pack Deletion',
  ConfirmECOExecution: 'Confirm ECO Execution',
  TemplateProperties: 'Template Properties',
  ConfirmPackClear: 'Confirm Pack Clear',
  EditDocumentTemplate: 'Edit Document Template',
  CreateDocumentTemplate: 'Create Document Template',
  ConfirmDocumentTemplateDeletion: 'Confirm Document Template Deletion',
  CreateNotificationTemplate: 'Create Notification Template',
  EditNotificationTemplate: 'Edit Notification Template',
  BulkPriceChange: 'Bulk Price Change',
  ImportGuidelines: 'Import Guidelines',
  ImportPartCost: 'Import Part Cost',
  PricingProperties: 'Pricing Properties',
  SelectDocument: 'Select a Document',
  InAppNotifications: 'In-app Notifications',
  SaveToSalesforce: 'Save to Salesforce',
  UnsavedPartPricing: 'Unsaved Part Pricing',
  SmartRevisionsL1: 'Smart Revisions',
  SmartRevisionsL2: 'Smart Revisions Import',
} as const;
